import React, { useState, useMemo } from 'react'
import styled from 'styled-components'
import media from 'styled-media-query'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Slider from 'react-slick'
import Spring from '../../molecules/Spring/spring'
import ContentModal from '../../molecules/ContentModal/ContentModal'
import useSegment from '../../../hooks/segment/useSegment'
import { delayBy } from '../../../utils/delayBy'
import VoBForm from '../../forms/VoBForm'
import {
  getAcceptedInsurance,
  getCenterProfileSlug,
  isStandard
} from '../../../domain/center'
import appendUtmSourceAndMediumToUrl from '../../../domain/appendUtmSourceAndMediumToUrl'
import Button from '../../atoms/Button/ButtonV2'
import { isNonEmptyString } from '../../../utils/checks'
import { getInsuranceLink } from '../../../domain/insurance/getInsuranceLink'

const Style = styled.div`
  .sliik {
    margin: 16px 0;
    ${media.greaterThan('900px')`
  width: 838px;
  `}
  }
  ${media.between('767px', '947px')`
  width: auto;
  margin-right: 16px;
  margin-left: 16px;

  `}

  flex-direction: column;
  ${media.greaterThan('medium')`
  border: 1px solid #E1E7EF;
  border-radius: 16px;
  `}
  margin-top: 30px;
  max-width: 915px;
  margin: 30px auto 77px;
  height: auto;
  background-color: #f8f9fb;
  display: flex;
  padding: 56px 57.5px 56px;
  ${media.lessThan('medium')`
    width: 100%;
    height: auto;
    padding: 32px 8px 18px 8px;
  `}
  ${media.lessThan('886px')`
    padding: 32px 8px 18px 8px;
  `}
  
  .title {
    margin-bottom: 32px;
    color: #162941;
    letter-spacing: -0.25px;
    ${media.lessThan('medium')`
      margin-bottom: 32px;
      font-size: 36px;
      font-weight: 400;
    `}
    font-style: normal;
    font-size: 36px;
    line-height: 40px;
    margin-right: auto;
    margin-left: auto;
  }
  .description {
    margin-bottom: 14px;
    ${media.lessThan('medium')`
      margin-bottom: 12px;
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 25.2px;
      text-align: center;
      `}
    color: #162941;
    font-size: 18px;
    max-width: 672px;
    margin-right: auto;
    margin-left: auto;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    text-align: center;
  }
  .images-container {
    display: flex;
    justify-content: center;
    & div {
      margin: 0 5px;
    }

    .sliik {
      width: auto;
    }
  }
  .slider-images-container {
    width: ${(props) =>
      props.count === 1
        ? '200px'
        : props.count === 2
        ? '400px'
        : props.count === 3
        ? '600px'
        : props.count === 4
        ? '100%'
        : '100%'};
    margin: auto;
    ${media.greaterThan('medium')`
    margin: auto 0px 24px -20px;
    `}
  }
  .slick-track {
    ${media.greaterThan('medium')`
      margin-left: 19px;
    `}
  }
  .slick-slide div:first-child {
    display: flex;
  }
  .slick-slide div:nth-child(2) {
    display: flex;
  }
  .insurance-images {
    max-width: 164px;
    ${media.lessThan('886px')`
    max-width: 15vw;
    
    `}
    ${media.lessThan('450px')`
    max-width: 103px;
    
    `}
  }
  .logo .logo-info {
    transition: 5s;
  }
  #image-container {
    .logo {
      opacity: 1;
      display: block !important;
    }
    .logo-info {
      opacity: 0;
      display: none !important;
    }
    ${media.greaterThan('medium')`
      :hover {
        .logo {
          opacity: 0;
          display: none !important;
        }
        .logo-info {
          opacity: 1;
          display: flex !important;
        }
      }
    `}

    max-width: 174px;
    min-width: 174px;
    max-height: 142px;
    min-height: 142px;
    ${media.lessThan('medium')`
      margin-left: 8px;
  `}
    ${media.lessThan('786px')`
    height: 100px;
    min-height: 100px;
    max-height: 100px;
  `}
    ${media.between('887px', '935px')`
  max-width: 170px;
  min-width: 170px;
  `}
  
  ${media.lessThan('886px')`
  height: 120px;
  min-height: 120px;
  max-height: 120px;
    max-width: 22vw;
    min-width: 22vw;
    width: 23vw;
    margin: auto;
    `}
    ${media.lessThan('450px')`
    max-height: 111px;
    margin: auto;
    height: 111px;
    min-height: 111px;
    max-width: 154px;
    min-width: 154px;
    width: 154px;

    `}
    background: #ffffff;
    border: 0.802646px solid #e1e7ef;
    border-radius: 12.8423px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .slick-dots {
    bottom: -65px;
    ${media.greaterThan('large')`
      transform: translate(0px, -16px);
      width: auto;
      left: 387px;
    `}
  }
  .slick-dots li.slick-active button:before {
    font-size: 12px;
  }
  .slick-dots li button:before {
    font-size: 8px;
  }
  .grid {
    display: grid;
    gap: 16px;
    grid-template-columns: auto auto;
  }
  .no-carousel {
    margin-top: 50px;
    ${media.lessThan('medium')`
    display: grid;
    gap: 16px;
    grid-template-columns: auto auto;
      
    `}
  }
  .footer-text {
    font-size: 12px;
    color: #677d95;
    padding: 0px 8px 14px;
    text-align: center;
  }
`

const settings = {
  dots: true,
  arrows: false,
  infinite: true,
  speed: 500,
  centerPadding: '160px',
  className: 'sliik',
  slidesToScroll: 4,
  slidesToShow: 4,
  rows: 1,
  slidesPerRow: 1,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesPerRow: 2,
        slidesToShow: 1,
        className: 'sliik',
        slidesToScroll: 1,
        rows: 2
      }
    }
  ]
}

const InsuranceInformation = ({
  insurance_description,
  showInfoLinks = false,
  verify_insurance_link,
  shouldShowVerifyBenefits,
  shouldDisplayInsuranceBlock,
  benefitsKey,
  benefitsProvider,
  disclaimer,
  centerTitle,
  center,
  phoneNumber
}) => {
  const [isInsuranceModalOpen, setIsInsuranceModalOpen] = useState(false)
  const [selectedInsurance, setSelectedInsurance] = useState({})
  const [isBenefitsModalOpen, setIsBenefitsModalOpen] = useState(false)

  const acceptedInsurance = getAcceptedInsurance(center)

  const analytics = useSegment()

  const handleHover = (event) => {
    event.currentTarget.style.transform = 'scale(1.18)'
    event.currentTarget.style.transition = '1s'
    if (document.querySelector('#slider-container')) {
      document.querySelector('#slider-container').className =
        'slider-images-container hovered'
    }
  }

  const handleMouseLeave = (event) => {
    event.currentTarget.style.transform = 'scale(1)'
    event.currentTarget.style.transition = '1s'
    if (document.querySelector('#slider-container')) {
      document.querySelector('#slider-container').className =
        'slider-images-container'
    }
  }
  const closeBenefitsModal = () => {
    setIsBenefitsModalOpen(false)
  }

  const openBenefitsModal = async () => {
    await delayBy(500)(setIsBenefitsModalOpen(true))
    analytics.verifyBenefits.opened({
      triggeredBy: 'Insurance Information Button'
    })
  }

  const handleOpenInsuranceModal = useMemo(
    () => (data) => {
      setIsInsuranceModalOpen(true)
      setSelectedInsurance(data)
    },
    []
  )

  const handleCloseInsuranceModal = () => {
    setIsInsuranceModalOpen(false)
  }

  if (!shouldDisplayInsuranceBlock) {
    return null
  }

  const useCenterWebsiteToVerifyInsurance = isNonEmptyString(
    verify_insurance_link
  )

  return (
    <Style
      count={4}
      acceptedInsurance={acceptedInsurance?.length > 0}
    >
      <p className="title">Insurance Accepted</p>
      <p className="description">
        <span className="mr-0.5 font-bold underline">Provider's Policy:</span>
        {insurance_description?.replace("Provider's Policy:", '') ||
          "To make sure you fully understand your benefits, we suggest reaching out to your insurance carrier directly. We're here to help with any questions you might have. Feel free to explore our website for more information on insurance options that might be right for you."}
      </p>
      {acceptedInsurance?.length > 0 && acceptedInsurance.length < 4 && (
        <div
          className="images-container no-carousel "
          style={{ position: 'relative' }}
        >
          {acceptedInsurance.map((insurance, index) => (
            <div
              key={index}
              style={{ display: 'flex', transition: '0.5s' }}
              className="sliik"
              onMouseEnter={handleHover}
              onMouseLeave={handleMouseLeave}
            >
              <div id="image-container">
                <div
                  className="logo"
                  onClick={() => {
                    handleOpenInsuranceModal({
                      img: insurance.insurance_logo,
                      title: insurance.title,
                      description: insurance.tooltipDescription,
                      link: insurance.tooltipLink
                    })
                  }}
                >
                  {insurance.insurance_logo ? (
                    <img
                      src={insurance.insurance_logo}
                      alt={insurance.title}
                      className="insurance-images"
                    />
                  ) : null}
                </div>
                <div className="logo-info p-2">
                  <div className="flex flex-col [zoom:0.75]">
                    {/* add tailwind class to the p tag below to limit the lines of text to 2 lines */}
                    <p className="text-sm font-semibold leading-4 text-gray-1100">
                      {insurance.title}
                    </p>
                    <p className="mb-2 mt-0.5 text-xs text-gray-1100">
                      {/* #15 most popular in California. */}
                      {insurance.tooltipDescription}
                    </p>
                    {!showInfoLinks && (
                      <a
                        className="text-xs font-semibold text-[#10629C]"
                        target="_self"
                        href={getInsuranceLink(
                          insurance.title,
                          center.locations,
                          insurance.tooltipLink
                        )}
                      >
                        See rehabs that accept this provider.
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      {isBenefitsModalOpen && (
        <ContentModal
          isOpen={isBenefitsModalOpen}
          onClose={closeBenefitsModal}
          headerText="Verification Of Benefits"
        >
          <VoBForm
            benefitsKey={benefitsKey}
            benefitsProvider={benefitsProvider}
            centerTitle={centerTitle}
            onClose={closeBenefitsModal}
          />
        </ContentModal>
      )}
      <Spring
        isOpen={isInsuranceModalOpen}
        onClose={handleCloseInsuranceModal}
        data={selectedInsurance}
        showInsuranceLink={isStandard(center)}
        centerLocations={center.locations}
      />
      {acceptedInsurance?.length > 3 && (
        <div
          className="slider-images-container"
          id="slider-container"
        >
          <Slider {...settings}>
            {acceptedInsurance?.map((insurance, index) => (
              <div
                key={index}
                style={{ display: 'flex', transition: '0.5s' }}
                className="sliik"
                onMouseEnter={handleHover}
                onMouseLeave={handleMouseLeave}
              >
                <div id="image-container">
                  <div
                    className="logo"
                    onClick={() => {
                      handleOpenInsuranceModal({
                        img: insurance.insurance_logo,
                        title: insurance.title,
                        description: insurance.tooltipDescription,
                        link: insurance.tooltipLink
                      })
                    }}
                  >
                    <img
                      src={insurance?.insurance_logo}
                      alt={insurance?.title}
                      className="insurance-images"
                    />
                  </div>
                  <div className="logo-info p-4">
                    <div className="flex flex-col [zoom:0.75]">
                      {/* add tailwind class to the p tag below to limit the lines of tex to 2 lines */}
                      <p className="text-sm font-semibold leading-4 text-gray-1100">
                        {insurance?.title}
                      </p>
                      <p
                        className="mb-2 mt-0.5 text-xs text-gray-1100"
                        dangerouslySetInnerHTML={{
                          __html: insurance?.tooltipDescription
                        }}
                      >
                        {/* #15 most popular in California. */}
                      </p>
                      {!showInfoLinks && (
                        <a
                          className="text-xs font-semibold text-[#10629C]"
                          href={getInsuranceLink(
                            insurance.title,
                            center.locations,
                            insurance.tooltipLink
                          )}
                          target="_self"
                        >
                          See rehabs that accept this provider.
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      )}

      <div
        className={`${
          acceptedInsurance || shouldShowVerifyBenefits
            ? 'pt-20 md:pt-16'
            : 'pt-0'
        } flex flex-col items-center justify-center gap-8`}
      >
        {shouldShowVerifyBenefits ? (
          <Button onClick={openBenefitsModal}>Call Us</Button>
        ) : (
          <Button
            as="a"
            className="verify"
            href={
              useCenterWebsiteToVerifyInsurance
                ? `${appendUtmSourceAndMediumToUrl(verify_insurance_link)}`
                : `tel: ${phoneNumber}`
            }
            onClick={() => {
              if (useCenterWebsiteToVerifyInsurance) {
                analytics.verifyBenefits.externalLink({
                  href: `${appendUtmSourceAndMediumToUrl(
                    verify_insurance_link
                  )}`
                })
                return
              }
              analytics.ui.callCta({
                number: phoneNumber,
                label: 'VOB',
                center_slug: getCenterProfileSlug(center)
              })
            }}
          >
            {useCenterWebsiteToVerifyInsurance
              ? 'Verify Insurance'
              : `${phoneNumber}`}
          </Button>
        )}{' '}
        <p
          className={`footer-text : flex ${
            acceptedInsurance || shouldShowVerifyBenefits ? 'mt-5' : 'mt-0'
          }`}
        >
          {disclaimer && disclaimer.length > 0 && { disclaimer }}

          {shouldShowVerifyBenefits &&
            !disclaimer &&
            `Verification of insurance benefits is a free service done by ${
              centerTitle || 'the center'
            }. Recovery.com is an independent third-party mental health resource.`}
        </p>
      </div>
    </Style>
  )
}

export default InsuranceInformation
